import axios from 'axios'

export const teacherRewards = {
	namespaced: true,
	state: {
		data: null,
		loading: false
	},
	getters: {
		loading: (state) => {
			return state.loading
		},
		teacherRewards: (state) => {
			return state.data
		}
	},
	mutations: {
		prepareConnect(state) {
			state.loading = true
		},
		stopLoading(state) {
			state.loading = false
		},
		setTeacherRewards(state, payload) {
			state.data = payload
			state.loading = false
		}
	},
	actions: {
		async fetchTeacherRewards({ commit }, payload) {
			commit('prepareConnect')
			const { teacherId, year, month, accessToken } = payload
			const header = {
				headers: {
					Authorization: `Bearer ${accessToken}`
				}
			}
			return axios
				.get(`/api/teachers/rewards?teacherId=${teacherId}&year=${year}&month=${month}`, header)
				.then((res) => {
					commit('setTeacherRewards', res.data.teacherRewards)
				})
				.catch(() => {
					commit('stopLoading')
				})
		}
	}
}
